import React from 'react'
import {LocationForm} from './LocationForm'

export function AccountCard({type, account, disabled, onChange, onBlur}) {
  return (
    <LocationForm
      account={account}
      values={account.values}
      errors={account.errors}
      touched={account.touched}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
    />
  )
}
